export const regularExpressions = {
  numberWithTwoNumberAfterFloatingPoint: new RegExp('^[0-9]*([,|.][0-9]{0,2})?$'),
}



// WEBPACK FOOTER //
// ./src/modules/forms/regularExpressions.ts